import { ref } from "vue";

export const deferredPrompt = ref();
